import { FC, ReactNode } from 'react';
import * as googleMaps from '@vis.gl/react-google-maps';
import { useProperties } from '@providers';

export type MapsApiProviderProps = {
  children: ReactNode;
};

const googleMapsApiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
if (!googleMapsApiKey) {
  throw new Error('VITE_GOOGLE_MAPS_API_KEY is not set');
}

export const MapsApiProvider: FC<MapsApiProviderProps> = (props) => {
  const { culture } = useProperties();

  return (
    <googleMaps.APIProvider apiKey={googleMapsApiKey} language={culture}>
      {props.children}
    </googleMaps.APIProvider>
  );
};
